import { defaultGridRowHeight } from '../Constants/Configuration'
import { updateLayoutFromObserver } from '../Slices/Kiosk/GridLayoutSlice'

const instantiateResizeObserver = dispatch => {
  return new ResizeObserver(entries => {
    if (entries && entries.length > 0) {
      const newHeights = []
      entries.forEach(entry => {
        if (entry) {
          const clientElement = entry
          const boxHeight = clientElement.borderBoxSize[0]?.blockSize
          const additionalMarginToAdd = 20
          const currentHeight = Math.ceil((boxHeight + additionalMarginToAdd) / defaultGridRowHeight)

          newHeights.push({ containerId: clientElement.target?.id, height: currentHeight })
        }
      })

      // const isElementResized = Boolean(observerBoxReference.current && observerBoxReference.current.getAttribute('data-resized') !== 'false');

      if (newHeights.length > 0) {
        dispatch(updateLayoutFromObserver(newHeights))
      }
    }
  })
}

const changeGridColumns = (gridLayout, gridOnOneColumn) => {
  const gridLayoutCopy = [...gridLayout]
  if (!gridOnOneColumn) {
    gridLayoutCopy.sort((a, b) => {
      return a.y - b.y
    })
  }

  return gridLayoutCopy.map((grid, index) => {
    const gridElement = { ...grid }
    gridElement.x = retrieveXPosition(gridOnOneColumn, index)
    gridElement.w = retrieveWidthInGridValue(gridOnOneColumn)

    return gridElement
  })
}

const addAndRemoveGridSection = (gridLayout, sectionId, gridOnOneColumn) => {
  const gridLayoutCopy = [...gridLayout]

  if (!gridOnOneColumn) {
    gridLayoutCopy.sort((a, b) => {
      return a.y - b.y
    })
  }

  const gridElementIndex = gridLayoutCopy.findIndex(x => x.i === sectionId)
  if (gridElementIndex !== -1) {
    const filteredGrid = gridLayoutCopy.filter(x => x.i !== sectionId)

    return filteredGrid.map((gridElement, index) => {
      const newGridEl = { ...gridElement }

      newGridEl.x = retrieveXPosition(gridOnOneColumn, index)
      return newGridEl
    })
  } else {
    const objToPush = {
      i: sectionId,
      x: retrieveXPosition(gridOnOneColumn, gridLayoutCopy.length),
      y: 9999, //higher y to set at last index,
      w: retrieveWidthInGridValue(gridOnOneColumn),
      h: 1,
      isDraggable: true,
      isBounded: true,
      resizeHandles: ['se'],
    }

    gridLayoutCopy.push(objToPush)

    return gridLayoutCopy
  }
}

const retrieveXPosition = (gridOnOneColumn, index) => {
  return gridOnOneColumn ? 0 : index % 2 === 0 ? 0 : 6
}

const retrieveWidthInGridValue = gridOnOneColumn => {
  return gridOnOneColumn ? 12 : 6
}

export { instantiateResizeObserver, changeGridColumns, addAndRemoveGridSection }
